import { Header, Spinner } from '@cloudscape-design/components';
import { WidgetConfig } from '../interfaces';
import GetWidgetData from '../../../../../../utils/getWidgetData';
import { useDashboardManager } from '../../hooks/useDashboardManager';
import { TrendInfo } from '../../components/trend-info';
import Alert from '@cloudscape-design/components/alert';
import { useDashboardContext } from '../../context/dashboardContext';
import { AverageSpeedOfAnswerStatsProvider } from './provider';

export const getAverageSpeedOfAnswerStats: WidgetConfig = {
  definition: { defaultRowSpan: 1, defaultColumnSpan: 1, minRowSpan: 1 },
  data: {
    icon: 'number',
    title: 'Avg Speed of Answer',
    description: 'ASA, plus 7 day average',
    header: ChartHeader,
    content: AverageSpeedOfAnswerStatsContent,
    provider: AverageSpeedOfAnswerStatsProvider,
    staticMinHeight: 560,
    multipleAllowed: true,
  },
};

function ChartHeader() {
  return (
    <Header
      variant='h2'
      description='ASA with 7 day average'
    >
      Avg Speed of Answer
    </Header>
  );
}

export default function AverageSpeedOfAnswerStatsContent({ widgetId }: { widgetId: string }) {
  const { dashboard } = useDashboardContext();
  const { getWidget } = useDashboardManager();
  const widget = getWidget(widgetId);
  const period = dashboard.data.period;
  const { data, isLoading, error } = GetWidgetData({ widget, period });

  if (error) {
    return (
      <Alert
        statusIconAriaLabel='Error'
        type='error'
        header='Unable to load widget'
      >
        {error.status}
      </Alert>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: '40px',
        justifyContent: 'center',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ fontSize: '6em', fontWeight: '800', textAlign: 'center' }}>{data?.data?.value !== null ? data?.data?.value : 'N/A'}</div>
        {data?.data?.trend !== undefined && (
          <TrendInfo
            trend={data?.data?.trend}
            value={data?.data?.value}
          />
        )}
      </div>
      {isLoading && <Spinner />}
    </div>
  );
}
